export default __webpack_public_path__ + "static/media/X.b156425f.svg";